
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns71352f47ab2b5a2074be0592ba8f12feen from './en.yaml'
            i18n.addResourceBundle('en', '71352f47ab2b5a2074be0592ba8f12fe', flattenObject(ns71352f47ab2b5a2074be0592ba8f12feen), true, true);
        
        export default '71352f47ab2b5a2074be0592ba8f12fe';
    